/**
 * Adjusts delivery time by combining deliveryFrom's date with deliveryTime's time.
 *
 * @param deliveryFrom - ISO string with date (and possibly time)
 * @param deliveryTime - ISO string with time (and possibly date)
 * @returns Combined ISO string, deliveryTime as-is, or null
 */
export function getAdjustedDeliveryTime(
	deliveryFrom?: string | null,
	deliveryTime?: string | null,
): string | null {
	if (!deliveryTime) return null;

	if (!deliveryFrom) {
		// No deliveryFrom → just return deliveryTime unchanged
		return deliveryTime;
	}

	const datePart = deliveryFrom.split('T')[0]; // YYYY-MM-DD
	const timePart = deliveryTime.split('T')[1]; // HH:mm:ss.sssZ (or similar)

	if (!datePart || !timePart) return deliveryTime;

	return `${datePart}T${timePart}`;
}


export function getDeliveryTimeFromDeliveryDate(deliveryDate?: string | null): string | null {
	if (!deliveryDate) return null;

	return deliveryDate.split('T')[1];
}